export default "__VITE_ASSET__Dj0FFXx1__"